//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WInput from './w-input'
import { XButton } from 'vux'

export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    disabled () {
      return this.username.length === 0 || this.password.length === 0
    }
  },
  methods: {
    async login () {
      this.$loading('登录中...')
      // 登录
      const res = await this.$login({
        username: this.username,
        password: this.password
      })
      if (res.code === 0) {
        // 连接socket
        await this.$connect()
        this.$hide()
        this.$router.replace({
          name: 'message',
          query: { mode: 'modal' }
        })
      } else {
        this.$toast(res.message)
      }
    }
  },
  components: {
    WInput,
    XButton
  }
}
